import DoughnutChartPage from '../../chart-molecules/DoughnutPage/DoughnutChartPage'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'

const ChannelChartContainerPage = (props: {
  colors: any
  icon: any
  detailTitle: string
  detailFooter: string
  firmList: any
  tooltipLabel: string
  labels: any
  response: any
  userInfo: any
  tabIndex: number
}) => {
  return (
    <div className="row">
      {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
        <div className="col-3 d-flex justify-content-between flex-column">
          <DoughnutChartPage
            colors={props.colors}
            labels={props.labels[0]}
            icon={props.icon}
            items={props.response}
            detailTitle={props.detailTitle}
          />

          <div>
            <p style={{ fontSize: '14px' }}>{props.detailFooter}</p>
          </div>
        </div>
      )}

      <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9' : 'col-12 '}>
        <StackedChart
          chartId="channelChart"
          tabIndex={props.tabIndex}
          colors={props.colors}
          checkedValue={''}
          setCheckedValue={''}
          labels={props.labels[1]}
          tooltipLabel={props.tooltipLabel}
          response={props.response}
          userInfo={props.userInfo}
        />
      </div>
    </div>
  )
}

export default ChannelChartContainerPage
